export default "__VITE_ASSET__B7W0Kxmz__"